import { ApolloLink } from "@apollo/client";
import { decodeOperationResponse } from "lib/internal/enigma/decodeOperationResponse";

export const decodeEnigmaticResponseLink = new ApolloLink((operation, forward) => {
  return forward(operation).map((response) => {
    return decodeOperationResponse(response);
  });
});
